module.exports = __webpack_public_path__ + "img/call-to-action-light.9d6adb27.png";